
export default {
  props: {
    tenant: {type: Object, required: true}
  },
  emits: ['submit'],
  data() {
    return {
      first_name: undefined,
      first_name_valid: false,
      last_name: undefined,
      last_name_valid: false,
      email: undefined,
      email_valid: false,
      google_email: false,
      is_superuser: false,
      is_beta: false,
      is_tenant_manager: false,
      af_topics: [],
      af_companies: []
    }
  },
  computed: {
    can_submit() {
      return this.first_name_valid && this.last_name_valid && this.email_valid
    }
  },
  methods: {
    open(){
      this.first_name = undefined
      this.first_name_valid = false
      this.last_name = undefined
      this.last_name_valid = false
      this.email = undefined
      this.email_valid = false
      this.google_email = false
      this.is_superuser = false
      this.is_beta = false
      this.is_tenant_manager = false
      this.af_topics = []
      this.af_companies = []

      this.$refs.modal.open()
      this.$nextTick(() => this.$refs.i_name.focus())
    },
    close() {
      this.$refs.modal.close()
    },
    submit() {
      this.close()
      this.$emit('submit', {
        first_name: this.first_name, 
        last_name: this.last_name,
        email: this.email,
        is_superuser: this.is_superuser,
        is_beta: this.is_beta,
        is_tenant_manager: this.is_tenant_manager,
        af_topics: this.af_topics,
        af_companies: this.af_companies,
        google_email: this.google_email,
      })
    },
  }
}
